export * from './user-settings.component';
export * from './user-settings.trans';
export * from './user-settings';
